import auth from "./auth"
import master from "./master"
import order from "./order"
import partner from "./partner"
import role from "./role"
import admin from "./admin"
import common from "./common"
import armada from "./armada"
import courier from "./courier"
import hub from "./hub"
import assignment from "./assignment"
import summary from "./summary"
import merchant from "./merchant"
import invoice from "./invoice"
import notification from "./notification"
import article from "./article"
import promo from "./promo"
import voucher from "./voucher"
import banner from "./banner"
import career from "./career"
import invoiceGenerator from "./invoiceGenerator"
import smesco from "./smesco"
import instantDelivery from "./instantDelivery"

const api = {
  auth,
  master,
  order,
  partner,
  role,
  admin,
  common,
  armada,
  courier,
  hub,
  assignment,
  summary,
  merchant,
  invoice,
  notification,
  article,
  promo,
  voucher,
  banner,
  career,
  invoiceGenerator,
  smesco,
  instantDelivery
}

export default api
